import { useTranslation } from "react-i18next";
import { TextField } from "@/shared/ui/core";
import { EditorialBlock, type EditorialBlockLocaleProps } from "./EditorialBlock";
import { useBlockFilled } from "./useBlockFilled";

/**
 * Bloque 1 · La etiqueta que va sobre la foto del héroe.
 *
 * Un solo campo, y aun así su propio bloque: es lo primero que se lee de
 * la ficha y mezclarlo con otra cosa lo escondería. "Nuevo", "Más
 * vendido", "Edición limitada".
 */
export function EditorialBadgeBlock({ locale }: EditorialBlockLocaleProps) {
  const { t } = useTranslation();
  const name = `editorial.${locale}.badgeLabel`;
  const filled = useBlockFilled(name);

  return (
    <EditorialBlock
      name={name}
      title={t("Etiqueta del héroe")}
      description={t("La palabra que va sobre la foto grande. Máximo 40 caracteres.")}
      filled={filled}
    >
      <TextField
        name={name}
        label={t("Etiqueta")}
        placeholder={t("Más vendido")}
        fieldClassName="sm:col-span-2"
      />
    </EditorialBlock>
  );
}
